import React from 'react'
import ReactDOM from 'react-dom/client'
import './locales/i18n'
import { Provider } from 'react-redux'
import store, { persistor } from './store/store'
import { PersistGate } from 'redux-persist/es/integration/react'
import App from './App'
import { LicenseInfo } from '@mui/x-license-pro';
import { ConfigProvider } from "./theme/mantis/contexts/configContext";
import 'simplebar/dist/simplebar.min.css';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { App as CapacitorApp } from "@capacitor/app";

LicenseInfo.setLicenseKey('ad2c5b4746060f7cbc69eb86fcad12a3Tz0xMjk5MjgsRT0xODEyMzI2Mzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y');

// 1️⃣ Capture deep links on cold start before React renders
CapacitorApp.addListener('appUrlOpen', ({ url }) => {
	try {
		if (url) {
			console.log('[ColdStart] Captured URL:', url);
			// Always store the full href for later use
			const parsed = new URL(url);
			sessionStorage.setItem('initialUrl', parsed.href);
		}
	} catch (err) {
		console.error('[ColdStart] Failed to store URL', err);
	}
});

// Suppress benign ResizeObserver loop errors (dev overlay blocks the screen)
const resizeObserverErrs = [
	'ResizeObserver loop completed with undelivered notifications.',
	'ResizeObserver loop limit exceeded',
];
window.addEventListener('error', (e) => {
	if (resizeObserverErrs.includes(e.message)) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}
}, true);
window.addEventListener('unhandledrejection', (e) => {
	if (e.reason?.message && resizeObserverErrs.includes(e.reason.message)) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}
});
// Standard workaround: wrap ResizeObserver callbacks in rAF so they don't fire mid-layout
const _ResizeObserver = window.ResizeObserver;
if (_ResizeObserver) {
	window.ResizeObserver = class extends _ResizeObserver {
		constructor(callback) {
			super((entries, observer) => {
				window.requestAnimationFrame(() => callback(entries, observer));
			});
		}
	};
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<GoogleOAuthProvider clientId='815430805890-lf8sivq7saavvg11s25s76e93egr5s3l.apps.googleusercontent.com'>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<ConfigProvider>
						<App/>
					</ConfigProvider>
				</PersistGate>
			</Provider>
		</GoogleOAuthProvider>
	</React.StrictMode>
)
